import { FC } from 'react';
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import GradientAiIcon from 'components/icons/GradientAiIcon';
import { Column } from 'further-ui/components/Layout';

const PRESET_QUESTIONS = [
  'Can you add an expense?',
  'Show me my investors',
  'Process a realisation',
  'Where is the balance sheet?',
];

const IdleText = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[500],
  maxWidth: '180px',
  textAlign: 'center',
}));

const PillsRow = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  overflowX: 'auto',
  flexWrap: 'nowrap',
  // hide the scrollbar
  '&::-webkit-scrollbar': { display: 'none' },
  scrollbarWidth: 'none',
}));

const QuestionPill = styled('button')(({ theme }) => ({
  border: `1px dashed ${theme.palette.grey[300]}`,
  backgroundColor: theme.palette.grey[100],
  borderRadius: 30,
  padding: theme.spacing(2, 3),
  cursor: 'pointer',
  color: theme.palette.grey[600],
  whiteSpace: 'nowrap',
  transition: 'background-color 0.15s, border-color 0.15s',

  '&:hover': {
    backgroundColor: theme.palette.grey[50],
    borderColor: theme.palette.grey[400],
  },
}));

type Props = {
  onSend: (text: string) => void;
  showPresets: boolean;
};

const EmptyState: FC<Props> = ({ onSend, showPresets }) => (
  <Column fullHeight spacing="md" justify="space-between">
    <Column centered spacing="sm" justify="center" flex={1}>
      <GradientAiIcon size={32} grey />
      <IdleText variant="body2">
        Chat with me about anything in the system.
      </IdleText>
    </Column>
    {showPresets && (
      <PillsRow>
        {PRESET_QUESTIONS.map((question) => (
          <QuestionPill key={question} onClick={() => onSend(question)}>
            {question}
          </QuestionPill>
        ))}
      </PillsRow>
    )}
  </Column>
);

export default EmptyState;
